<div class="search-container" [ngClass]="mode">
  <div class="search-row" #searchRow>
    <!-- WHAT -->
    <div class="field-group what" (click)="activate('what')" [class.active]="activeField === 'what'">
      <label>What</label>
      <input type="text" placeholder="Vehicles, Equipments, Machineries" [(ngModel)]="whatValue"
        (focus)="activate('what')" (input)="activate('what')" />

      <!-- Clear Button for What field -->
      <span class="clear-icon" *ngIf="whatValue" (click)="clearWhat($event)">&times;</span>

      <!-- class="value-box" -->
      <div class="category-popup" *ngIf="showCategories" (click)="$event.stopPropagation()">
        <h4>Categories</h4>
        <div class="category-list">
          <div class="category-item" *ngFor="let cat of filteredCategories"
            (click)="selectCategory(cat); $event.stopPropagation()">
            <img [src]="cat.imageUrl" *ngIf="cat.imageUrl" />
            <span>{{ cat.name }}</span>
          </div>
          <div class="no-results" *ngIf="filteredCategories.length === 0">
            No categories found
          </div>
        </div>
      </div>
    </div>

    <!-- WHERE -->
    <div class="field-group emirate-field" (click)="activate('where')" [class.active]="activeField === 'where'">
      <label>Where</label>
      <div class="value-box">{{ selectedEmirate || "Select Emirate" }}</div>

      <div class="emirate-popup" *ngIf="showEmirates" (click)="$event.stopPropagation()">
        <h4>Search by Emirate</h4>
        <div class="emirate-grid">
          <div class="emirate-item" [class.selected]="selectedEmirate === emirate.name" *ngFor="let emirate of emirates"
            (click)="chooseEmirate(emirate.name); $event.stopPropagation()">
            <img [src]="emirate.map" />
            <span>{{ emirate.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- DATE FROM -->
    <div class="field-group small" (click)="activate('from')" [class.active]="activeField === 'from'">
      <label>From When</label>
      <div class="value-box">{{ selectedStart || "Start date" }}</div>

      <div class="calendar-dropdown" *ngIf="showCalendarFrom" (click)="$event.stopPropagation()">
        <div class="calendar-header">
          <span class="chevron" (click)="prevMonth(); $event.stopPropagation()">&lsaquo;</span>
          <h3 style="margin: 0px !important">
            {{ currentMonthName }} {{ currentYear }}
          </h3>
          <span class="chevron" (click)="nextMonth(); $event.stopPropagation()">&rsaquo;</span>
        </div>

        <div class="calendar-weekdays">
          <span *ngFor="let d of weekdays">{{ d }}</span>
        </div>

        <div class="calendar-grid">
          <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
            [class.is-today]="day.isToday" [class.is-past]="day.isPast"
            (click)="selectStart(day); $event.stopPropagation()">
            {{ day.date }}
          </span>
        </div>
      </div>
    </div>

    <!-- DATE TO -->
    <div class="field-group small" (click)="activate('to')" [class.active]="activeField === 'to'">
      <label>Till When</label>
      <div class="value-box">{{ selectedEnd || "End date" }}</div>

      <div class="calendar-dropdown" *ngIf="showCalendarTo" (click)="$event.stopPropagation()">
        <div class="calendar-header">
          <span class="chevron" (click)="prevMonth(); $event.stopPropagation()">&lsaquo;</span>
          <h3>{{ currentMonthName }} {{ currentYear }}</h3>
          <span class="chevron" (click)="nextMonth(); $event.stopPropagation()">&rsaquo;</span>
        </div>

        <div class="calendar-weekdays">
          <span *ngFor="let d of weekdays">{{ d }}</span>
        </div>

        <div class="calendar-grid">
          <span *ngFor="let day of calendarDays" class="day" [class.inactive]="day.inactive"
            [class.is-today]="day.isToday" [class.is-past]="day.isPast"
            (click)="selectEnd(day); $event.stopPropagation()">
            {{ day.date }}
          </span>
        </div>
      </div>
    </div>

    <!-- SEARCH BUTTON -->
    <button class="search-btn" (click)="emitSearch()">
      <span class="material-icons">search</span>
      <span class="btn-text">Search</span>
    </button>
  </div>
</div>